import { DefaultSections, startPresentation } from "@presentation/Types";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import ThankYou from "./Slides/IntroAndOutro/ThankYou.vue";
import SoftMarket from "./Slides/Challenges/SoftMarket.vue";
import Goodwill from "./Slides/Challenges/Goodwill.vue";
import Solution from "./Slides/Challenges/Solution.vue";
import Results from "./Slides/SuccessLeavesATrail/Results.vue";
import BuyerInterest from "./Slides/SuccessLeavesATrail/BuyerInterest.vue";
import Clues from "./Slides/SuccessLeavesATrail/Clues.vue";
import LoyaltyPrograms from "./Slides/SuccessLeavesATrail/LoyaltyPrograms.vue";
import AirlineLoyaltyExample from "./Slides/SuccessLeavesATrail/AirlineLoyaltyExample.vue";
import ConnectedVehiclesOverview from "./Slides/History/ConnectedVehiclesOverview.vue";
import OurHistory from "./Slides/History/OurHistory.vue";
import WeAreHere from "./Slides/History/WeAreHere.vue";
import ResellerProposition from "./Slides/ResellerProposition/ResellerProposition.vue";
import ResellerBenefits from "./Slides/ResellerProposition/ResellerBenefits.vue";
import ProtectSummary from "./Slides/ConsumerProposition/ProtectSummary.vue";
import CarbucksProtectVideo from "./Slides/ConsumerProposition/CarbucksProtectVideo.vue";
import CarbucksProtectCategories from "./Slides/ConsumerProposition/CarbucksProtectCategories.vue";
import CarbucksProtectProfit from "./Slides/ConsumerProposition/CarbucksProtectProfit.vue";
import MarketplaceFeatures from "./Slides/Marketplace/MarketplaceFeatures.vue";
import MarketplacePartners from "./Slides/Marketplace/MarketplacePartners.vue";
import ExclusiveResellerOpportunity from "./Slides/ResellerProposition/ExclusiveResellerOpportunity.vue";
import OpportunityCalculator from "./Slides/ResellerProposition/OpportunityCalculator.vue";
import CarbucksRewards from "./Slides/ConsumerProposition/CarbucksRewards.vue";
import ExecutiveSummary1 from "./Slides/ExecutiveSummary/ExecutiveSummary-1.vue";
import ExecutiveSummary2 from "./Slides/ExecutiveSummary/ExecutiveSummary-2.vue";
import ExecutiveSummary3 from "./Slides/ExecutiveSummary/ExecutiveSummary-3.vue";
import ExecutiveSummary4 from "./Slides/ExecutiveSummary/ExecutiveSummary-4.vue";

export const useResellerPresentation = () => startPresentation(
{

    key: 'reseller',
    title: 'Reseller Presentation',
    password: 'singapore', 
    enableNextSlideIndicator: true,

    theme: {
        logo: '/connected-vehicles-text-dark-mode.png',
        logoClass: '!h-4 -mt-2 2xl:!h-5 2xl:-mt-6 opacity-80'
    },

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Introduction }
            ],
            images: [
                '/connected-vehicles-logo-icon.png',
                '/connected-vehicles-text-dark-mode.png',
                '/background-overlay.jpg',
                '/pending.jpg'
            ]
        },

        // Executive Summary
        { 
            name: 'executive-summary', 
            title: 'Executive Summary',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: ExecutiveSummary1, title: 'Challenges' },
                { component: ExecutiveSummary2, title: 'Background' },
                { component: ExecutiveSummary3, title: 'Opportunity / Expectations' },
                { component: ExecutiveSummary4, title: 'Proven Formula' },
            ],
            images: [
                '/Background/background-1.jpg'
            ]   
        },

        // Success Leaves a Trail
        // { 
        //     name: 'success-leaves-a-trail', 
        //     title: 'Success Leaves a Trail',
        //     displayPageTitle: true,
        //     isAppendix: false,
        //     hasTitlePage: true,
        //     pages: [
        //         { component: Clues },
        //         { component: Results },
        //         { component: BuyerInterest },
        //         // { component: Subscriptions },
        //         { component: LoyaltyPrograms },
        //         { component: AirlineLoyaltyExample },
        //     ],
        //     images: [
        //         '/SuccessLeavesATrail/buyer-interest.png',
        //         '/SuccessLeavesATrail/subscriptions.jpg',
        //         '/SuccessLeavesATrail/results.png',
        //         '/SuccessLeavesATrail/loyalty-programs.png',
        //         '/SuccessLeavesATrail/airline-example.png'
        //     ]   
        // },

        // What is Carbucks
        // { 
        //     name: 'what-is-carbucks', 
        //     title: 'What is Carbucks?',
        //     displayPageTitle: true,
        //     isAppendix: false,
        //     hasTitlePage: true,
        //     pages: [
        //         { component: TheCarbucksApp },
        //         { component: HealthMonitoring },
        //         { component: Concierge },
        //         { component: Marketplace },
        //         { component: Dashboard },
        //         { component: PutItAllTogether, title: 'Put it all together' }
        //     ],
        //     images: [
        //         '/WhatIsCarbucks/product-overview.png',
        //         '/WhatIsCarbucks/health-monitoring.png',
        //         '/WhatIsCarbucks/app.png',
        //         '/WhatIsCarbucks/dashboard.png',
        //         '/WhatIsCarbucks/concierge.png',
        //         '/WhatIsCarbucks/marketplace.png',
        //         '/WhatIsCarbucks/summary-1.png',
        //         '/WhatIsCarbucks/summary-2.png',
        //         '/WhatIsCarbucks/carbucks.png',
        //         '/WhatIsCarbucks/careplan.png',
        //         '/WhatIsCarbucks/carbucks-protect.png'
        //     ]   
        // },

        // Carbucks PROTECT
        { 
            name: 'carbucks-protect', 
            title: 'Carbucks PROTECT',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: CarbucksProtectVideo, title: 'Speed To Revenue' },
                // { component: CarbucksProtect, title: "Here's What's Included" },
                { component: CarbucksProtectCategories, title: 'Great Benefits, Great Margins' },
                { component: CarbucksProtectProfit, title: 'Great Benefits, Great Margins' },
                { component: ProtectSummary, title: 'New Upfront Revenue' },
            ],
            images: [
                '/ConsumerProposition/carbucks-rewards-logo.png',
                '/ConsumerProposition/carbucks-protect-logo.png',
                '/DealerProposition/early-bird-discount-smooth.png',
                '/DealerProposition/carbucks-dashboard-logo.png',
                '/background-overlay-4.jpg',
            ]   
        },

        // Consumer Proposition
        { 
            name: 'consumer-proposition', 
            title: 'Carbucks REWARDS',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: LoyaltyPrograms, title: 'Missing from Automotive' },
                { component: AirlineLoyaltyExample, title: 'Genuine revenue source, not a bolt on' },
                { component: CarbucksRewards, title: 'Boosts Retention & Ongoing Revenue' },
                { component: MarketplaceFeatures },
                { component: MarketplacePartners }
            ],
            images: [
                '/ConsumerProposition/carbucks-rewards-logo.png',
                '/ConsumerProposition/carbucks-protect-logo.png',
                '/Marketplace/marketplace-triangle-nodes.png',
                '/Marketplace/marketplace-triangle-arrows-1.png',
                '/Marketplace/marketplace-triangle-arrows-2.png',
                '/Marketplace/marketplace-triangle-arrows-3.png',
                '/Marketplace/marketplace-triangle-phone-1.png',
                '/Marketplace/marketplace-triangle-phone-2.png',
                '/Marketplace/dan-murphey.png',
                '/Marketplace/choice.png',
                '/Marketplace/big-w.png',
                '/Marketplace/bws.png',
                '/Marketplace/virgin.png',
                '/Marketplace/freely.png',
                '/Marketplace/booking.png',
                '/Marketplace/omio.png',
                '/Marketplace/adidas.png',
                '/Marketplace/pay-by-card.jpg',
                '/Marketplace/visa.png',
                '/Marketplace/mastercard.png',
                '/Marketplace/eftpos.png',
                '/Marketplace/google-pay.png',
                '/Marketplace/samsung-pay.png',
                '/Marketplace/apple-pay.png',
            ]   
        },

        // Reseller Proposition
        // Reseller Benefits
        { 
            name: 'reseller-opportunity', 
            title: 'Reseller Opportunity',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: OpportunityCalculator },
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },


        // What We're Looking For
        { 
            name: 'reseller-what-we-need', 
            title: "What we're Looking For",
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: ExclusiveResellerOpportunity },
                // { component: ResellerProposition },
                { component: ResellerBenefits, title: 'Reseller Benefits' },
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },

        // Thank You
        { 
            name: DefaultSections.End, 
            title: 'Questions',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: ThankYou }
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },
        
        // Case Study
        { 
            name: 'case-study'  
        },

        // Point of Sale
        { 
            name: 'point-of-sale'
        },

        // Terms and Conditions
        { 
            name: 'terms-and-conditions'
        },

        // Dealer Cashback
        { 
            name: 'dealer-cashback'  
        },

        // DMS Integration
        { 
            name: 'dms-integration'
        },

        // Our History
        { 
            name: 'history', 
            title: 'Our History',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: ConnectedVehiclesOverview, title: 'Company Overview', hideTitle: true },
                { component: OurHistory, title: 'Our History' },
                { component: WeAreHere, title: "We are Here" },
            ],
            images: [
                '/History/connected-vehicles-logo-white.png',
                '/History/dealercell.jpg',
                '/History/we-are-here.jpg'
            ]   
        },

    ]

})
